import React from "react";
import { Box, Typography, IconButton, Paper } from "@mui/material";
import { DoubleArrow } from "@mui/icons-material";
import { CustomTextBox } from "components/CustomComponents";
import { useForm } from "react-hook-form";
import { CustomButton } from "components/CustomComponents/CustomButton";
import { customAPI } from "services/utils/CustomAPI";
import {
  doubleArrowStyle,
  themes,
  parentBoxStyle,
  childBoxStyleWithColor,
  infoStyle,
  toAlignEnd,
  childBoxStyle,
} from "services/constants";
import { useSelector } from "react-redux";
import { showToast } from "services/utils/Status";
import { atleastOneCharacterWithSpace } from "services/constants/patterns";

export const CreateEmployeeGroup = ({
  onClose,
  reCallApi,
  setHandleLoader,
}) => {
  const {
    setValue,
    handleSubmit,
    register,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    defaultValues: {
      group_name: "",
    },
  });
  const { domain } = useSelector((state) => state.tokenReducer);

  const onSubmit = async () => {
    setValue("button_loader", true);
    const response = await customAPI(`${domain}employee-group/`, "POST", {
      group_name: watch("group_name").trim(),
    });
    if (response.ok) {
      showToast("success", response?.responseDetails?.message);
      setValue("button_loader", false);
      onClose();
      setHandleLoader(false);
      reCallApi(true);
    } else {
      setValue("button_loader", false);
      showToast("error", response?.message);
    }
  };

  const handleGroupName = (event) => {
    setValue("group_name", event.target.value);
  };

  return (
    <Box sx={parentBoxStyle}>
      <Paper
        elevation={0}
        sx={{
          borderBottom: `1px solid ${themes?.miliedLightGray}`,
          borderRadius: 0,
        }}
      >
        <Box sx={childBoxStyleWithColor}>
          <Box sx={{ ml: 1 }}>
            <IconButton onClick={onClose} sx={doubleArrowStyle}>
              <DoubleArrow />
            </IconButton>
          </Box>

          <Box sx={{ ml: 2.2 }}>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              Employee Group
            </Typography>
            <Typography {...infoStyle}>Create a employee group</Typography>
          </Box>
        </Box>
      </Paper>

      <form onSubmit={handleSubmit(onSubmit)}>
        <Box sx={{ flexGrow: 1, overflow: "auto", p: 2 }}>
          <Box sx={childBoxStyle}>
            <Box>
              <Typography sx={{ fontWeight: 600 }}>Group Name</Typography>
              <CustomTextBox
                rules={{
                  ...register("group_name", {
                    required: "Employee group name is required",
                    minLength: {
                      value: 3,
                      message: "Minium length is 3 characters",
                    },
                    maxLength: {
                      value: 100,
                      message: "Maximum length is 100 characters",
                    },
                    validate: {
                      atleastOneCharacterWithSpaceReg: (value) => {
                        if (
                          atleastOneCharacterWithSpace.test(value) ||
                          value === ""
                        ) {
                          return true;
                        } else {
                          return "Atleast one alphabet required";
                        }
                      },
                    },
                  }),
                }}
                selectedValue={watch("group_name")}
                updateDataFunction={handleGroupName}
                placeHolder="Enter employee group name"
                errorMessage={
                  errors?.group_name?.message ? errors?.group_name?.message : ""
                }
                textBoxError={errors?.group_name ? true : false}
              />
            </Box>

            <Box sx={toAlignEnd}>
              <CustomButton
                actionFuntion={handleSubmit(onSubmit)}
                actionName="Create"
                typeName="submit"
                disableAction={watch("button_loader")}
              />
            </Box>
          </Box>
        </Box>
      </form>
    </Box>
  );
};
